<div #phonesetting>
  <div class="menu">
    <span class="menu-heading">Phone Settings</span>
    <span class="close" (click)="closePhoneSettingsPopup()">X</span>
  </div>
  <div class="row console">
    <label class="item-list"> <input type="checkbox" [disabled]="isDisabled" [(ngModel)]="useSoftPhone"
        id="chksoftphone" (change)="onsoftphonechkChange($event)"> Use Soft Phone</label>
    <div id="phonenumber" [hidden]="useSoftPhone"> <br>
      <input type="text" placeholder=" Phone Number" (keypress)="numbersOnly($event)" class="txt-box"
        [(ngModel)]="txtphonenumber" /><br><br>
    </div>
    <ng-container *ngIf="useSoftPhone">
      <div id="softphone" [hidden]="!useSoftPhone">
        <span class="txt-desc">Soft Phone is required</span> <br>
        <span class="txt-heading">Audio Input Source</span>
        <select name="roledropdown" class="drpdown-input-box" [(ngModel)]="selectedInputDeviceId"
          (change)="onInputDeviceChange()">
          <option [ngValue]="option.deviceId" *ngFor="let option of audioInputDevices">{{option.label}} </option>

        </select><br>
        <span class="txt-heading">Audio Output Source</span>
        <select name="roledropdown" class="drpdown-input-box" [(ngModel)]="selectedOutputDeviceId"
          (change)="onOutputDeviceChange()">
          <option [ngValue]="option.deviceId" *ngFor="let option of audioOutputDevices">{{option.label}} </option>

        </select>

        <div>
          <meter id="audio-meter" min="0" max="1" low="0.3" high="0.7" optimum="0.9"></meter>
        </div>

        <div class="button-container">
          <button type="button" class="run-btn" [disabled]="isRunningDiagnostics"
            *ngIf="!isAudioTesting || isRunningDiagnostics" (click)="runDiagnostics()">
            {{ isRunningDiagnostics ? 'Running...' : 'Call Test' }}
          </button>
          <button type="button" class="run-btn" [disabled]="isAudioTesting" (click)="runAudioRecordingTest()"
            *ngIf="!isRunningDiagnostics || isAudioTesting">
            {{ isAudioTesting ? audioTestingButtonText : 'Speaker Test' }}
          </button>
          <button type="button" class="run-btn stop-btn" *ngIf="isRunningDiagnostics || isRecording"
            (click)="onStopClick()">
            Stop
          </button>
        </div>
        <!-- Diagnostics result for common -->
        <div class="diagnostics-result phonesettingFont" *ngIf="diagnosticResult.status !== 'idle'"
          [ngClass]="diagnosticResult.status">
          <strong>Status:</strong>
          {{ diagnosticResult.status | titlecase }}

          <span>{{ diagnosticResult.message }}</span>
        </div>
        <!-- Audio Diagnostics summary -->
        <details class="summary-card collapsible-card raw-report phonesettingFont"
          *ngIf="audioTestResult.status !== 'idle'" open>
          <summary>
            Audio Test Result
            <span class="summary-status phonesettingFont" [ngClass]="{
            passed: audioTestResult.status === 'passed',
            failed: audioTestResult.status === 'failed',
            warning: audioTestResult.status === 'warning'
          }">
              {{ audioTestResult.status | titlecase }}
            </span>
          </summary>

          <div class="summary-inner">
            <p class="summary-message phonesettingFont">
              {{ audioTestResult.message }}
            </p>
            <div class="summary-content phonesettingFont">
              <div class="summary-row">
                <span>Input Device</span>
                <strong>{{ audioTestResult.inputDeviceName || '-' }}</strong>
              </div>

              <div class="summary-row">
                <span>Output Device</span>
                <strong>{{ audioTestResult.outputDeviceName || '-' }}</strong>
              </div>

              <div class="summary-row">
                <span>Microphone Permission</span>
                <strong>{{ audioTestResult.microphonePermission }}</strong>
              </div>

              <div class="summary-row">
                <span>Recording</span>
                <strong>{{ audioTestResult.recordingStatus }}</strong>
              </div>

              <div class="summary-row">
                <span>Playback</span>
                <strong>{{ audioTestResult.playbackStatus }}</strong>
              </div>

              <div class="summary-row">
                <span>Browser Support</span>
                <strong>{{ audioTestResult.browserSupport }}</strong>
              </div>
            </div>

            <audio class="recorded-audio-player " *ngIf="recordedAudioUrl" [src]="recordedAudioUrl" controls></audio>
          </div>
        </details>

        <!-- Diagnostics summary -->
        <details class="summary-card collapsible-card raw-report phonesettingFont" *ngIf="preflightSummary"
          [open]="isSummaryExpanded" (toggle)="isSummaryExpanded">
          <summary class="collapsible-summary phonesettingFont">
            <span>Diagnostics Summary</span>

            <span class="summary-status phonesettingFont" [ngClass]="{
            passed: preflightSummary.overallStatus === 'Passed',
            failed: preflightSummary.overallStatus === 'Failed',
            warning: preflightSummary.overallStatus === 'Warning'
          }">
              {{ preflightSummary.overallStatus }}
            </span>
          </summary>

          <div class="summary-inner phonesettingFont">
            <div class="summary-actions phonesettingFont">
              <button type="button" class="copy-btn" (click)="copyPreflightSummary()">
                Copy Summary
              </button>
            </div>

            <p class="summary-message phonesettingFont">
              {{ preflightSummary.message }}
            </p>

            <div class="summary-content phonesettingFont">
              <div class="summary-row">
                <span>Call SID</span>
                <strong>{{ preflightSummary.callSid }}</strong>
              </div>

              <div class="summary-row">
                <span>TURN Required</span>
                <strong>{{ preflightSummary.turnRequired }}</strong>
              </div>

              <div class="summary-row">
                <span>Region / Edge</span>
                <strong>{{ preflightSummary.selectedRegion }}</strong>
              </div>

              <div class="summary-row">
                <span>Network Speed</span>
                <strong>{{ preflightSummary.networkSpeed }}</strong>
              </div>

              <div class="summary-row">
                <span>Physical Network Type</span>
                <strong>{{ preflightSummary.networkType }}</strong>
              </div>

              <div class="summary-row">
                <span>Effective Network Type</span>
                <strong>{{ preflightSummary.effectiveNetworkType }}</strong>
              </div>

              <div class="summary-row">
                <span>Browser Network RTT</span>
                <strong>{{ preflightSummary.browserNetworkRtt }}</strong>
              </div>

              <div class="summary-row">
                <span>Packet Loss</span>
                <strong>{{ preflightSummary.packetLoss }}</strong>
              </div>

              <div class="summary-row">
                <span>Jitter</span>
                <strong>{{ preflightSummary.jitter }}</strong>
              </div>

              <div class="summary-row">
                <span>Twilio/WebRTC RTT</span>
                <strong>{{ preflightSummary.rtt }}</strong>
              </div>

              <div class="summary-row">
                <span>MOS / Audio Score</span>
                <strong>{{ preflightSummary.mos }}</strong>
              </div>

              <div class="summary-row">
                <span>Codec</span>
                <strong>{{ preflightSummary.codec }}</strong>
              </div>

              <div class="summary-row">
                <span>Warnings</span>
                <strong>{{ preflightSummary.warningCount }}</strong>
              </div>
            </div>
          </div>
        </details>

        <!-- Warnings -->
        <div class="warning-card" *ngIf="warnings.length">
          <h3>Warnings</h3>

          <div class="warning-item" *ngFor="let warning of warnings">
            {{ warning.name }}
          </div>
        </div>

        <!-- Raw report -->
        <details class="summary-card collapsible-card raw-report phonesettingFont" *ngIf="finalReport">
          <summary>View Raw Preflight Report</summary>

          <div class="raw-report-actions">
            <button type="button" class="copy-btn" (click)="copyRawPreflightReport()">
              Copy Raw Report
            </button>
          </div>

          <pre>{{ finalReport | json }}</pre>
        </details>

        <!-- Error details -->
        <details class="raw-report" *ngIf="diagnosticResult.error">
          <summary>View Error Details</summary>
          <pre>{{ diagnosticResult.error | json }}</pre>
        </details>

        <div class="copy-message phonesettingFont" *ngIf="copySuccessMessage">
          {{ copySuccessMessage }}
        </div>
      </div>
    </ng-container>

  </div>
  <br>
  <div class="menu-bottom text-center bottom-border">
    <div id="phonenumber" [hidden]="useSoftPhone" (click)="SaveChanges()">
      <button class="nav-btn1">Save Changes</button>
    </div>
    <div id="phonenumber" [hidden]="!useSoftPhone" (click)="SaveChanges()">
      <button class="nav-btn1">Ok</button>
    </div>
  </div><br>
</div>